export class Categories {
  static cats: Array<string> = [
    'Abgeschlossenheit',
    'Abgeschlossenheit/Anlagen/Bauplan',
    'Abgeschlossenheit/Anlagen/Berechnungen',
    'Abgeschlossenheit/Anlagen/Plankarten',
    'Abloesevollmacht',
    'Abloesevollmacht/Allianz',
    'Abloesevollmacht/BHW',
    'Abloesevollmacht/DSL',
    'Abloesevollmacht/Hanseatic',
    'Abloesevollmacht/SKG',
    'Abloesevollmacht/Santander',
    'Abloesevollmacht/Sparkasse',
    'Abloesevollmacht/Targobank',
    'Abloesevollmacht/Kreditauszahlung',
    'Abtretung',
    'Abtretung/Anzeige',
    'Abtretung/Bausparvertrag',
    'Abtretung/Bautraeger_Finanzierungsbestaetigung',
    'Abtretung/Gehalt',
    'Abtretung/Kraftfahrzeug',
    'Abtretung/Lebensversicherung',
    'Abtretung/Mietforderung',
    'Altersvorsorge',
    'Altersvorsorge/Betrieblich',
    'Altersvorsorge/Privat',
    'Anmeldebestaetigung',
    'Anmeldebestaetigung/Ersatzformulare',
    'Anmeldebestaetigung/Selbstnutzung',
    'Anschriftenaenderung',
    'Ausweis',
    'Ausweis/Personalausweis',
    'Ausweis/Reisepass',
    'BWA',
    'BWA/Bilanz',
    'BWA/EA-Rechnung',
    'BWA/GuV',
    'BWA/Handelsregisterauszug',
    'BWA/Jahresabschluss',
    'Bauantrag',
    'Bauantrag/Anlagen',
    'Bauantrag/Anlagen/Abgeschlossenheit',
    'Bauantrag/Anlagen/Baubeschreibung',
    'Bauantrag/Anlagen/Bauplan',
    'Bauantrag/Anlagen/Berechnungen',
    'Bauantrag/Anlagen/Bescheinigung',
    'Bauantrag/Anlagen/Plankarten',
    'Baubeschreibung',
    'Baugenehmigung',
    'Baugenehmigung/Anlagen',
    'Baugenehmigung/Anlagen/Bescheinigung',
    'Baugenehmigung/Anlagen/Gebuehrenbescheid',
    'Baugenehmigung/Anlagen/Statistik',
    'Baulasten',
    'Baulasten/Anlagen/Plankarten',
    'Baulasten/Baulastauskunft',
    'Baulasten/Baulasteneintragung',
    'Bauplan',
    'Baurechtsauskunft',
    'Baurechtsauskunft/Auskunftseinwilligung',
    'Bauspar_Jahreskontoauszug',
    'Bausparantrag',
    'Bausparantrag/Produktinfo_AGB',
    'Bausparantrag/VVI',
    'Bausparvertrag',
    'Bausparvertrag/Bauspar_Zuteilungsschreiben',
    'Bausparvertrag/Bausparurkunde',
    'Begleitschreiben',
    'Begleitschreiben/Anschreiben_Bank',
    'Begleitschreiben/Anschreiben_Kunde',
    'Begleitschreiben/Sonst_Schriftverkehr',
    'Beratungsdokument',
    'Beratungsdokument/Checkliste',
    'Beratungsdokument/Deckblatt',
    'Beratungsdokument/Informationsblatt',
    'Beratungsdokument/Postident',
    'Beratungsdokument/Tilgungsplan',
    'Beratungsprotokoll',
    'Beratungsprotokoll/Ratenschutz',
    'Beratungsprotokoll/Ratenschutz/Santander',
    'Beratungsprotokoll/Ratenschutz/Targobank',
    'Berechnungen',
    'Berechnungen/Kubatur',
    'Berechnungen/Wohnflaeche',
    'Besichtigungsauftrag',
    'Besichtigungsbericht',
    'DVV_VVI',
    'DVV_VVI/DKBG',
    'DVV_VVI/Privatkredit',
    'Darlehensantrag',
    'Darlehensantrag/Allianz',
    'Darlehensantrag/BHW',
    'Darlehensantrag/Bausparkassen',
    'Darlehensantrag/Commerzbank',
    'Darlehensantrag/Degussa',
    'Darlehensantrag/DKB',
    'Darlehensantrag/DSL',
    'Darlehensantrag/DSL_Nachrang',
    'Darlehensantrag/DTBANK',
    'Darlehensantrag/ING',
    'Darlehensantrag/PSD',
    'Darlehensantrag/SPARDA',
    'Darlehensantrag/Sonstige',
    'Darlehensantrag/Sparkasse',
    'Darlehensantrag/VOLKSBANK',
    'Darlehensantrag/Anlagen/SEPA_Mandat',
    'ESM',
    'ESM/Allianz',
    'ESM/BHW',
    'ESM/Commerzbank',
    'ESM/DKB',
    'ESM/DSL',
    'ESM/DTBANK',
    'ESM/Hanseatic',
    'ESM/ING',
    'ESM/Privatkredit',
    'ESM/PSD',
    'ESM/Sparkassen',
    'ESM/SPARDA',
    'ESM/VOLKSBANK',
    'Ehevertrag',
    'Einkommensteuer',
    'Einkommensteuer/Anlagen/BWA',
    'Einkommensteuer/Steuerbescheid',
    'Einkommensteuer/Steuererklaerung',
    'Elterngeldbescheid',
    'Empfangsbestaetigung',
    'Energieausweis',
    'Erbbaurechtsvertrag',
    'Erbbaurechtsvertrag/Anlagen',
    'Erbbaurechtsvertrag/Anlagen/Abgeschlossenheit',
    'Erbbaurechtsvertrag/Erklaerung',
    'Erlaeuterungsprotokoll',
    'Eroeffnung_Girokonto',
    'Erschliessung',
    'Erschliessung/Anlagen/Plankarten',
    'Expose',
    'Expose/Anlagen/Bauplan',
    'Expose/Anlagen/Berechnungen',
    'Expose/Anlagen/Energieausweis',
    'Expose/Anlagen/Objektfotos',
    'Expose/Anlagen/Plankarten',
    'Expose/Kurz_Expose',
    'Faelligkeitsmitteilung',
    'Finanzierungsvorschlag',
    'Finanzierungsvorschlag_Antwort',
    'Finanzierungsvorschlag_Antwort/Mit_Schufa',
    'Finanzierungszusage',
    'Finanzierungszusage/vorlaeufig',
    'Foerderdarlehen',
    'Foerderdarlehen/Finanzierungszusage',
    'Freistellungsvereinbarung',
    'Gebaeudeversicherung',
    'Gebaeudeversicherung/Haftpflicht',
    'Gebaeudeversicherung/Jahresrechnung',
    'Gebaeudeversicherung/Nachtrag',
    'Gebaeudeversicherung/Risikoleben',
    'Gebaeudeversicherung/Vertrag',
    'Gehaltsabrechnung',
    'Grundbuchauszug',
    'Grundbuchauszug/Eintragungsbekanntmachung',
    'Grundbuchauszug/Erbbaugrundbuch',
    'Grundbuchauszug/Mitteilungen',
    'Grunderwerbsteuer',
    'Grunderwerbsteuer/Grundsteuer',
    'Grundschuldbestellung',
    'Grundschuldbestellung/Grundschuldbrief',
    'Grundschuldbestellung/Loeschung',
    'Grundschuldbestellung/Schuldanerkenntnis',
    'Grundschuldbestellung/Treuhandauftrag',
    'Inkasso',
    'Inkasso/Kuendigung',
    'Kaufvertrag',
    'Kaufvertrag/Anlagen',
    'Kaufvertrag/Anlagen/Abgeschlossenheit',
    'Kaufvertrag/Anlagen/Baubeschreibung',
    'Kaufvertrag/Anlagen/Bauplan',
    'Kaufvertrag/Anlagen/Plankarten',
    'Kaufvertrag/Anlagen/Werkvertrag',
    'Kaufvertrag/Anlagen/Zahlungsplan',
    'Kaufvertrag/Begleitnotizen',
    'Kaufvertrag/Erschliessungsvertrag',
    'Kaufvertrag/Negativzeugnis',
    'Kaufvertrag/Uebertragungsvertrag',
    'Kaufvertrag/Kaufabsichtserklaerung',
    'KfW_Antrag',
    'KfW_Antrag/Nachweis',
    'KfW_Antrag/Einwilligung',
    'KfW_Antrag/Allianz',
    'KfW_Antrag/Commerzbank',
    'KfW_Antrag/DSL',
    'KfW_Antrag/ING',
    'KfW_Antrag/KfW_Beiblatt',
    'KfW_Antrag/Produktanbieterantrag',
    'KfW_Antrag/Produktinfo',
    'KfW_Antrag/Sparkassen',
    'KfW_Antrag/VOLKSBANK',
    'KfW_Antragsbestaetigung',
    'KfW_Durchfuehrungsbestaetigung',
    'Kontoauszug',
    'Kontoauszug/Darlehen',
    'Kontoauszug/Depot',
    'Kontoauszug/Finanzstatus',
    'Kontoauszug/Kreditkartenumsatz',
    'Kontoauszug/Schenkung',
    'Kontoauszug/Unterhalt',
    'Kostenaufstellung',
    'Kostenaufstellung/Angebot',
    'Kostenaufstellung/Eigenleistungen',
    'Krankenversicherungsnachweis',
    'Krankenversicherungsnachweis/Aenderungsmitteilung',
    'Krankenversicherungsnachweis/Bescheinigung',
    'Krankenversicherungsnachweis/Versicherungsschein',
    'Legitimationspruefung',
    'Lohnsteuerbescheinigung',
    'Mietvertrag',
    'Mietvertrag/Mieteraufstellung',
    'Mietvertrag/Verwaltervertrag',
    'Nachrangdarlehen',
    'Nachrangdarlehen/Finanzierungszusage',
    'Nachrangdarlehen/Hanseatic',
    'Objektfotos',
    'Objektfotos/Baufortschritt',
    'Objektfotos/aussen',
    'Objektfotos/innen',
    'Plankarten',
    'Plankarten/BORIS',
    'Plankarten/Bebauungsplan',
    'Plankarten/Flurkarte',
    'Plankarten/Fortfuehrungserklaerung',
    'Plankarten/Lageplan',
    'Plankarten/Textform',
    'Privatkreditvertrag',
    'Privatkreditvertrag/Commerzbank',
    'Privatkreditvertrag/DKB',
    'Privatkreditvertrag/DSL',
    'Privatkreditvertrag/Finanzierungszusage',
    'Privatkreditvertrag/ING',
    'Privatkreditvertrag/Norisbank',
    'Privatkreditvertrag/DTBANK',
    'Privatkreditvertrag/SKG',
    'Privatkreditvertrag/Santander',
    'Privatkreditvertrag/Sparkasse',
    'Privatkreditvertrag/Targobank',
    'Ratenschutzversicherung',
    'Ratenschutzversicherung/Allianz',
    'Ratenschutzversicherung/ZURICH',
    'Ratenschutzversicherung/BHW_GVV',
    'Ratenschutzversicherung/BHW_GVV/VVI',
    'Ratenschutzversicherung/Hanseatic',
    'Ratenschutzversicherung/Postbank',
    'Ratenschutzversicherung/PB_Leben',
    'Ratenschutzversicherung/PB_Leben_indicated',
    'Ratenschutzversicherung/SPARDA',
    'Ratenschutzversicherung/Targobank',
    'Rechnung_Quittung',
    'Rechnung_Quittung/Betriebskosten',
    'Rechnung_Quittung/Konsumkaufvertrag',
    'Rechnung_Quittung/Notarkosten',
    'Rentenbescheid',
    'Renteninformation',
    'SEPA_Mandat',
    'SEPA_Mandat/BHW',
    'SEPA_Mandat/DSL',
    'SEPA_Mandat/Allianz',
    'SEPA_Mandat/Targobank',
    'Saldenmitteilung',
    'Saldenmitteilung/Valutenbescheinigung',
    'Scheidungsbeschluss',
    'Scheidungsfolgevereinbarung',
    'Scheidungsfolgevereinbarung/Entwurf',
    'Scheidungsfolgevereinbarung/Trennungsvereinbarung',
    'Selbstauskunft',
    'Selbstauskunft/Ergaenzung',
    'Selbstauskunft/Stellungnahme',
    'Selbstauskunft/Datenschutzhinweis',
    'Selbstauskunft/Schufa_Datenschutzklausel',
    'Selbstauskunft/Bankauskunft',
    'Selbstauskunft/Werbeeinverstaendnis',
    'Selbstauskunft/Auslaender',
    'Sicherungsvereinbarung',
    'Sonstige_Einnahmen',
    'Sonstige_Einnahmen/Krankengeld',
    'Sonstige_Einnahmen/Pflegegeld',
    'Sonstige_Einnahmen/Rentenzahlung',
    'Teilungserklaerung',
    'Teilungserklaerung/Anlagen',
    'Teilungserklaerung/Anlagen/Abgeschlossenheit',
    'Teilungserklaerung/Anlagen/Baubeschreibung',
    'Teilungserklaerung/Anlagen/Baugenehmigung',
    'Teilungserklaerung/Anlagen/Baulasten',
    'Teilungserklaerung/Anlagen/Bauplan',
    'Teilungserklaerung/Anlagen/Berechnungen',
    'Teilungserklaerung/Anlagen/Erbbaurechtsvertrag',
    'Teilungserklaerung/Anlagen/Mietvertrag',
    'Teilungserklaerung/Anlagen/Plankarten',
    'Teilungserklaerung/Anlagen/Verwaltervertrag',
    'Teilungserklaerung/Anlagen/Eigentuemerversammlung',
    'Teilungserklaerung/Vollmacht',
    'Uebergabeprotokoll',
    'Ueberweisungsbeleg',
    'Unterhaltsnachweis',
    'Unterhaltsnachweis/Beschluss',
    'Unterhaltsnachweis/Schreiben_vom_Amt',
    'Unterhaltsnachweis/Urkunde',
    'Unterhaltsnachweis/persoenliche_Erklaerung',
    'Unterlage_Arbeitgeber',
    'Unterlage_Arbeitgeber/Arbeitsvertrag',
    'Unterlage_Arbeitgeber/Bescheinigung',
    'Unterlage_Arbeitgeber/Elternzeit',
    'Unterlage_Arbeitgeber/Ernennungsurkunde',
    'Unterlage_Arbeitgeber/Weiterbeschaeftigung',
    'Vermittlerabfrage',
    'Vermoegensuebersicht',
    'Werkvertrag',
    'Werkvertrag/Anlagen',
    'Werkvertrag/Anlagen/Bauplan',
    'Werkvertrag/Anlagen/Berechnungen',
    'Werkvertrag/Anlagen/Objektfotos',
    'Werkvertrag/Anlagen/Zahlungsplan',
    'Wertgutachten',
    'Wertgutachten/Anlagen',
    'Wertgutachten/Anlagen/Bauplan',
    'Wertgutachten/Anlagen/Objektfotos',
    'Wertgutachten/Anlagen/Plankarten',
    'Wertgutachten/Kurzgutachten',
    'Wertgutachten/Vollgutachten',
    'Wertindikation',
    'Zahlungsabruf',
    'Zahlungsabruf/Baufortschritt',
    'Zahlungsabruf/Objektfotos',
    'Zahlungsabruf/Sofortige_Auszahlung',
    'Zahlungsabruf/Verwendungsnachweis',
    'Zahlungsabruf/Targobank',
    'Zahlungsplan',
    'Zustellungsvollmacht',
    'Zustimmungserklaerung',
    'Zustimmungserklaerung/Stillhalteerklaerung',
    // special
    'Leerseite',
    'Nicht_Klassifizierbar',
  ];
}
